import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Content from "../Modulos/InspecaoAmbiental/Home/Content";

const InspecaoAmbiental = () => {
    return (
        <>
            <NavBar title="INSPEÇÃO AMBIENTAL" goBackOnePage />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    );
};

export default InspecaoAmbiental;
